// apis/medicalCertificate.js
import api from "../axios/axios-config";

// Create a new medical certificate
export const createMedicalCertificate = async (payload) => {
  try {
    const response = await api.post("/medicalCertificate", payload);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

// Fetch all medical certificates for a patient
export const getMedicalCertificates = async (patientId) => {
  try {
    const response = await api.get(`/medicalCertificate/${patientId}`);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

// Update an existing medical certificate
export const updateMedicalCertificate = async (id, payload) => {
  try {
    const response = await api.put(`/medicalCertificate/${id}`, payload);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

// Delete a medical certificate
export const deleteMedicalCertificate = async (id) => {
  try {
    const response = await api.delete(`/medicalCertificate/${id}`);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};
